import DataViewerCardModel from "../../dashboard/DataViewerCardModel.js";
import DataViewerModel from "../../DataViewerModel.js";
export default function convert(old, opts) {
  const {
    settingsRoot,
    usedSettingsPath,
    getSettingsAt
  } = opts;
  const settings = getSettingsAt(settingsRoot);
  usedSettingsPath.add(settingsRoot);
  const nType = 'molten.Map';
  const r = DataViewerCardModel.create(DataViewerModel.create(nType, settings));
  if (old?.height) {
    r.height = old.height;
  }
  return r;
}
convert.TYPE = 'dashboard.MapCard';